import DesignGuide from "./DesignGuide"

export default DesignGuide
